export interface AnonymousTurnstileGateInput {
	isAnonymous: boolean;
	turnstileEnabled: boolean;
	turnstileToken: string | null;
	clearanceToken: string | null;
}

/**
 * Returns whether an anonymous analysis submission needs a Turnstile token.
 *
 * The client-side control must match the submit handler: when the feature flag
 * disables Turnstile, no token is required; the server remains authoritative
 * for quota and verification enforcement.
 */
export function requiresAnonymousTurnstileVerification({
	isAnonymous,
	turnstileEnabled,
	turnstileToken,
	clearanceToken,
}: AnonymousTurnstileGateInput): boolean {
	return (
		isAnonymous &&
		turnstileEnabled &&
		!turnstileToken &&
		!clearanceToken
	);
}
